module.exports = __webpack_public_path__ + "img/stock3.47feaf8a.png";